import { supabase } from '@/lib/supabase'
import type { FinanceExpenseCategory, FinanceMonthlyFactRow, FinanceMonthlyFactValues } from '@/lib/financeMonthlyFacts'

function errorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object' && 'message' in error) {
    const message = String((error as { message?: unknown }).message ?? '').trim()
    if (message) return message
  }
  return fallback
}

export async function getFinanceMonthlyPilotAccess(studioInternalId: number): Promise<boolean> {
  const response = await (supabase as any).rpc('finance_monthly_pilot_can_access', {
    p_studio_internal_id: studioInternalId,
  })
  if (response.error) throw new Error(errorMessage(response.error, 'Не удалось проверить доступ к ДДС/PnL'))
  return response.data === true
}

export async function getFinanceMonthlyExpenseFacts(
  studioInternalId: number,
  year: number
): Promise<FinanceMonthlyFactRow[]> {
  const response = await (supabase as any).rpc('get_finance_monthly_expense_facts', {
    p_studio_internal_id: studioInternalId,
    p_year: year,
  })
  if (response.error) throw new Error(errorMessage(response.error, 'Не удалось загрузить расходы'))
  return (Array.isArray(response.data) ? response.data : []) as FinanceMonthlyFactRow[]
}

export async function getFinanceExpenseCategories(studioInternalId: number): Promise<FinanceExpenseCategory[]> {
  const response = await (supabase as any).rpc('get_finance_expense_categories', {
    p_studio_internal_id: studioInternalId,
  })
  if (response.error) throw new Error(errorMessage(response.error, 'Не удалось загрузить справочник расходов'))
  return (Array.isArray(response.data) ? response.data : []) as FinanceExpenseCategory[]
}

export async function saveFinanceMonthlyExpenseFacts(input: {
  studioInternalId: number
  monthStart: string
  values: FinanceMonthlyFactValues
  expectedVersion: number | null
}): Promise<FinanceMonthlyFactRow> {
  const response = await (supabase as any).rpc('save_finance_monthly_expense_facts', {
    p_studio_internal_id: input.studioInternalId,
    p_month_start: input.monthStart,
    p_values: input.values,
    p_expected_version: input.expectedVersion,
  })
  if (response.error) throw new Error(errorMessage(response.error, 'Не удалось сохранить расходы'))
  return response.data as FinanceMonthlyFactRow
}
